<template>
  <div class="auth-box-w">
    <el-steps :active="active" finish-status="success" align-center>
      <el-step :title="$t('Check email address')"></el-step>
      <el-step :title="$t('Verification code')"></el-step>
      <el-step :title="$t('Reset')"></el-step>
    </el-steps>
    <MailAddressForm
      @goForward="goForward"
      @getVerifyData="getVerifyData"
      @getUserLevel="getUserLevel"
      v-if="active === 0"
    />
    <CodeForm
      :verifyData="verifyData"
      @goForward="goForward"
      @getVerifyData="getVerifyData"
      :user="user"
      v-if="active === 1"
    />
    <PasswordForm
      :email="verifyData.email"
      @goForward="goForward"
      :user="user"
      v-if="active === 2"
    />
    <Success @goForward="goForward" v-if="active === 3" />
  </div>
</template>

<script>
import MailAddressForm from './MailAddressForm';
import CodeForm from './DigitsForm';
import PasswordForm from './PasswordForm';
import Success from './Success';
import Button from '@/components/uikit/Button';

import jaTranslations from '@/i18n/langs/ja';
import enTranslations from '@/i18n/langs/en';

export default {
  name: 'ChangePassword',
  i18n: {
    en: {
      ...enTranslations,
    },
    ja: {
      ...jaTranslations,
    },
  },
  components: {
    MailAddressForm,
    CodeForm,
    PasswordForm,
    Success,
    Button,
  },
  data() {
    return {
      active: 0,
      verifyData: {
        email: '',
        hash: '',
        second: '',
      },
      user: {
        id: '',
        level: '',
      },
    };
  },
  methods: {
    goForward(num) {
      this.active = num;
    },
    getVerifyData(value) {
      this.verifyData.email = value.email;
      this.verifyData.hash = value.hash;
      this.verifyData.second = value.second;
    },
    getUserLevel(value) {
      this.user.id = value.id;
      this.user.level = value.level;
    },
  },
};
</script>

<style scoped>
.auth-box-w form {
  padding: 20px 60px;
}
</style>
